import { motion } from "framer-motion";
import {
  Palette,
  Gauge,
  ShieldCheck,
  Headset,
} from "lucide-react";

const features = [
  {
    icon: Palette,
    title: "Modern Design",
    description: "Clean & User Friendly",
  },
  {
    icon: Gauge,
    title: "Performance",
    description: "Fast & Optimized",
  },
  {
    icon: ShieldCheck,
    title: "Secure",
    description: "Reliable & Safe",
  },
  {
    icon: Headset,
    title: "Support",
    description: "Always here for you",
  },
];

export default function SubHero() {
  return (
    <section className="-mt-10 relative z-20 px-6 py-10">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="max-w-7xl mx-auto bg-white rounded-[30px] border border-gray-200 shadow-xl"
      >
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 px-10 py-8">

          {features.map((item, index) => {
            const Icon = item.icon;

            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 25 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{
                  duration: 0.6,
                  delay: index * 0.15,
                }}
                whileHover={{
                  y: -6,
                  transition: { duration: 0.25 },
                }}
                className="flex items-center gap-5 cursor-pointer"
              >
                {/* Icon */}
                <motion.div
                  whileHover={{
                    rotate: 8,
                    scale: 1.1,
                  }}
                  className="w-20 h-20 rounded-full bg-blue-100 flex items-center justify-center"
                >
                  <Icon
                    size={34}
                    className="text-[#075DA8]"
                  />
                </motion.div>

                {/* Text */}
                <div>
                  <h3 className="text-xl font-semibold text-gray-900">
                    {item.title}
                  </h3>

                  <p className="text-gray-500 mt-1">
                    {item.description}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </motion.div>
    </section>
  );
}